import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../../../utils/common'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../../../Checkbox'
import { EntityArchivedIcon } from '../../../../../Entity'
import Text from '../../../../../Text'
import { getIsCalendarFollowUpMovable } from '../../../../Calendar.utils'

import { QA_NAME_CALENDAR_RELIEVE_DAY_FOLLOW_UP } from './FollowUpRow.constants'
import { getCalendarRelieveDayFollowUpLockedKey } from './FollowUpRow.utils'

import * as styles from './FollowUpRow.module.css'

function FollowUpRow({ followUp, isChecked, isDisabled, onToggle }) {
  const { t } = useTranslation()

  const isMovable = getIsCalendarFollowUpMovable(followUp)

  function handleChange(nextIsChecked) {
    onToggle({ followUp, isChecked: nextIsChecked })
  }

  return (
    <div
      {...getQaSelector({
        context: followUp.id,
        value: QA_NAME_CALENDAR_RELIEVE_DAY_FOLLOW_UP,
      })}
      className={styles.FollowUpRow}
    >
      <Checkbox
        checked={isChecked}
        disabled={isDisabled || !isMovable}
        label={followUp.title}
        labelClassName={styles.label}
        labelTitleClassName={styles.title}
        qaName={QA_NAME_CALENDAR_RELIEVE_DAY_FOLLOW_UP}
        showTooltip={!isMovable}
        size={CHECKBOX_SIZE.small}
        tooltip={
          isMovable ? null : t(getCalendarRelieveDayFollowUpLockedKey(followUp))
        }
        type={CHECKBOX_TYPE.action}
        onChange={handleChange}
      />
      {followUp.isArchived ? <EntityArchivedIcon /> : null}
      <Text isSecondary className={styles.assignees}>
        {followUp.secondaryLabel}
      </Text>
    </div>
  )
}

export default FollowUpRow
